import React from "react";
import { Link } from "react-router-dom";

const LOGOS = {
  primary: "/logos/logo-primary.webp",
  light: "/logos/logo-light.webp",
  black: "/logos/logo-black.webp",
  white: "/logos/logo-white.webp",
  isotype: "/logos/isotype.png",
};

// variant: primary | light | white | black | isotype
export const Logo = ({ variant = "primary", className = "", height = 44, to = "/", testId = "wanm-logo" }) => {
  const src = LOGOS[variant] || LOGOS.primary;
  const img = (
    <img
      src={src}
      alt="WANM — We Are Nation Media"
      style={{ height, width: "auto" }}
      className="block select-none"
      draggable={false}
    />
  );
  if (to === false) return <span className={className} data-testid={testId}>{img}</span>;
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid={testId} aria-label="WANM home">
      {img}
    </Link>
  );
};

export default Logo;
